import React, { useEffect, useState } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";
import { useQuery } from "@apollo/client";
import { GET_NOTICES_COUNT } from "../../../../quries/notice";
import { GET_SCHEDULES_COUNT } from "../../../../quries/schedule";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      widht: "100%",
      "& > *": {
        marginTop: theme.spacing(2),
      },
    },
  })
);

interface SchedulePaginationProps {
  //   pageIndex: number;
  //   setPageIndex: any;
  history: any;
  match: any;
}

export default function SchedulePagination({
  //   pageIndex,
  //   setPageIndex,
  history,
  match,
}: SchedulePaginationProps) {
  const classes = useStyles();
  const [count, setCount] = useState<number | null>(null);

  const [pageIndex, setPageIndex] = useState<any>(null);
  useEffect(() => {
    console.log(match.params.page_id);
    if (match.params.page_id === undefined) {
      setPageIndex(1);
    } else {
      let num: number = parseInt(match.params.page_id);
      setPageIndex(num);
    }
    return () => {
      setPageIndex(null);
    };
  }, [match.params.page_id]);
  const { data, loading, error } = useQuery(GET_SCHEDULES_COUNT, {
    fetchPolicy: "no-cache",
  });
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    // history.push(`/schedule/${value}`);
    console.log(value);

    setPageIndex(value);
    history.push(`/schedule/${value}`);
  };

  useEffect(() => {
    if (data && data.schedulesCount) {
      let countNumber = Math.ceil(data.schedulesCount / 10)
      // let a = parseInt(data.schedulesCount);

      console.log("올림", Math.ceil(21/ 10));
      console.log("수", countNumber);
      setCount(countNumber);
    }
    return () => {
      setCount(null);
    };
  }, [data]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.schedulesCount) {
    console.log(error);
  }

  return (
    <div className={classes.root}>
      {count && pageIndex ? (
        <div>
          <Pagination
            count={count}
            // defaultPage={6}
            // boundaryCount={2}
            // style={{ fontSize: 32 }}
            page={pageIndex}
            onChange={handleChange}
            color="primary"
          />
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}
